import { useState } from "react"
import { router } from "@inertiajs/react"
import { Trash2 } from "lucide-react"
import {
  AlertDialog, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter,
  AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from "@/components/ui/alert-dialog"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"

// Deleting a Kingdom Factors book (#674) cannot be undone, so the coach or
// admin types the book's title first. The server checks the title too
// (Book#delete!).
export function DeleteBookDialog({ title, path, note }) {
  const [open, setOpen] = useState(false)
  const [typed, setTyped] = useState("")
  const [deleting, setDeleting] = useState(false)
  const matches = typed.trim().toLowerCase() === title.toLowerCase()

  const remove = () => {
    setDeleting(true)
    router.delete(path, { data: { confirm: typed }, onFinish: () => setDeleting(false) })
  }

  return (
    <AlertDialog open={open} onOpenChange={(next) => { setOpen(next); if (!next) setTyped("") }}>
      <AlertDialogTrigger asChild>
        <Button size="sm" variant="outline" className="border-red-200 text-red-700 hover:bg-red-50 hover:text-red-800">
          <Trash2 className="h-4 w-4" /> Delete this book
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent className="bg-white">
        <AlertDialogHeader>
          <AlertDialogTitle>Delete {title}?</AlertDialogTitle>
          <AlertDialogDescription className="space-y-2">
            <span className="block">This deletes every chapter, every version, the sources, the Brand checks, and every print file. You cannot undo it.</span>
            {note && <span className="block">{note}</span>}
            <span className="block">To delete it, type the title: <b className="text-zinc-900">{title}</b></span>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <Input value={typed} onChange={(e) => setTyped(e.target.value)} placeholder={title} aria-label="Type the book's title" autoFocus />
        <AlertDialogFooter>
          <AlertDialogCancel disabled={deleting}>Cancel</AlertDialogCancel>
          <Button className="bg-red-600 text-white hover:bg-red-700" disabled={!matches || deleting} onClick={remove}>
            <Trash2 className="h-4 w-4" /> {deleting ? "Deleting…" : "Delete the book"}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
